import actionTypes from '../../actions/actionTypes';

const _initState = {
  isLoading: false,
  file: null
};

const fakturaPDF = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_FAKTURA_PDF_REQUEST:
      return { ...state, isLoading: true, file: null };

    case actionTypes.GET_FAKTURA_PDF_SUCCESS:
      return { ...state, isLoading: false, file: action.res };
    
    case actionTypes.GET_FAKTURA_PDF_FAILURE:
      return _initState;

    default:
      return state
  }
};

export default fakturaPDF;